{
  "SET_NEW_PASSWORD": {
    "TITLE": "Nustatyti naują slaptažodį",
    "PASSWORD": {
      "LABEL": "Slaptažodis",
      "PLACEHOLDER": "Slaptažodis",
      "ERROR": "Slaptažodis yra pertrumpas."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Patvirtinti slaptažodį",
      "PLACEHOLDER": "Patvirtinti slaptažodį",
      "ERROR": "Slaptažodžiai nesutampa."
    },
    "API": {
      "SUCCESS_MESSAGE": "Sėkmingai pakeistas slaptažodis.",
      "ERROR_MESSAGE": "Nepavyko prisijungti prie Woot serverio. Bandykite dar kartą vėliau."
    },
    "CAPTCHA": {
      "ERROR": "Patvirtinimo galiojimo laikas baigėsi. Prašome dar kartą išspręsti captcha."
    },
    "SUBMIT": "Pateikti"
  }
}
